import React, { useState, useEffect } from 'react'

import { filterTypesEnum, FilterTypesInWords } from '../../enum/filterType.enum'
import { IActiveFilterViewer } from '../../interfaces/activeFiltersViewerProps'
import FilterSimple from './filter-simple'
import styles from './index.module.scss'
import translationsTemplate from '../../constants/translations'
import { isObject, mergeDeep } from '../../helpers/mergeDeep'
import { IFilterDataArray, IFilterGroupedData, IFilterOption } from '../../interfaces/filterProps'
import FilterAdvance from './filter-advance'
import { arrayGroupBy } from 'helpers/filter'

export const ActiveFilterViewer: React.FC<IActiveFilterViewer> = ({ activeFilters, locale = undefined, columns, onChange, openFilters, fixedFilters = undefined }) => {
  const { simple, advance } = filterTypesEnum
  const { simple: filterSimple } = FilterTypesInWords
  const [type, setType] = useState(simple)
  const [translations, setTranslations] = useState(translationsTemplate.filters)
  const [columnsData, setColumnsData] = useState([] as IFilterOption[])
  const [data, setData] = useState([] as IFilterDataArray[])
  const [fixed, setFixed] = useState([] as IFilterDataArray[])

  const [advanceFilterData, setAdvanceFilterData] = useState([] as IFilterGroupedData[])

  useEffect(() => {
    if (columns) setColumnsData(columns)
  }, [columns])

  useEffect(() => {
    const { data, filterType } = activeFilters
    setType(filterType === filterSimple ? simple : advance)
    const aux = (data || []).filter(({ compareTo }) => !!compareTo)
    setData(aux)
  }, [activeFilters])

  useEffect(() => {
    if (fixedFilters !== undefined) {
      const { data } = fixedFilters
      const aux = (data || []).filter(({ compareTo }) => !!compareTo)
      setFixed(aux)
    }
  }, [fixedFilters])

  useEffect(() => {
    isObject(locale) && Object.keys(locale).length > 0 && setTranslations(mergeDeep(locale, translationsTemplate.filters))
  }, [locale])

  useEffect(() => {
    const { filterType, groupedData } = activeFilters
    filterType === FilterTypesInWords.advance && setAdvanceFilterData(groupedData || arrayGroupBy(data, 'group'))
  }, [data])

  const handleClose = (index: number) => {
    const aux = data.slice()
    aux.splice(index, 1)

    const grouped = arrayGroupBy(aux, 'group')
    // GROUP INDEX FIX
    const rows = [] as any
    grouped.map((row: any) => {
      row.data.map((data: any) => {
        rows.push(data)
      })
    })

    onChange({ ...activeFilters, data: rows, groupedData: grouped })
  }

  const handleClear = () => {
    setData([])
    onChange({ ...activeFilters, data: [], groupedData: [] })
  }

  return (
    <div className="rankmiTable-activeFilterViewer">
      {(!!data.length || fixedFilters) && (
        <div className={`${styles.container}`}>
          {type === simple ? (
            <FilterSimple columns={columnsData} data={data} fixed={fixed} translations={translations} onClear={handleClear} onClose={handleClose} />
          ) : (
            <FilterAdvance columns={columnsData} data={advanceFilterData} fixed={fixed} openFilters={openFilters} translations={translations} onClear={handleClear} onClose={handleClose} />
          )}
        </div>
      )}
    </div>
  )
}
